import React from 'react';
import { List } from 'immutable';
import { Node } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';


import Button from '../../../components/Button';
import Container from '../../../components/Container';

import './style.scss';

const ParagraphProjects = ({ entity }) => {
  let link;
  if (entity.get('field_link')) {
    link = (
      <Button
        href={entity.getIn(['field_link', 0, 'uri'], '')}
        primary
        withIcon
        buttonIcon
      >
        {entity.getIn(['field_link', 0, 'title'], '')}
      </Button>
    );
  }
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <div id={paragraphKey} className="Paragraph ParagraphProjects">
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <div className="Projects">
          <Container>
            <div className="row">
              {
                entity.getIn(['field_related_content'], List()).map((item) => {
                  const nodeId = item.get('target_id');
                  const node = item.getIn(['entity']);
                  return (
                    <div key={nodeId} className="col-12 col-xs-12 col-sm-4">
                      <Node entity={node} id={nodeId} viewMode="teaser" />
                    </div>
                  );
                })
              }
            </div>
          </Container>
        </div>
        <Container>
          <div className="ParagraphProjects__button">{ link }</div>
        </Container>
      </Fade>
    </div>
  );
};

export default ParagraphProjects;
